// Deliberately NOT derived from Vite's `base` (see vite.config.ts / BASE_VITE).
// In develop & prod, assets live under a versioned prefix (/releases/<sha>/)
// for caching, but index.html gets promoted to the bucket root, so the app
// is actually browsed at domain root — router basename must stay '/' there.
// Only PR previews are genuinely served under a URL prefix end-to-end, so
// CI sets BASE_ROUTER to match BASE_VITE for those builds only.
export const basename =
  (process.env.BASE_ROUTER ?? '/').replace(/\/$/, '') || '/';

// Prefix an absolute path with the router basename. Only needed for
// navigation that bypasses React Router context (e.g. calling `history.push`
// directly outside a component) — `useNavigate`/`<Navigate>` already do this
// automatically once `basename` is set on the `Router`.
export const withBasename = (path: string): string =>
  basename === '/' ? path : `${basename}${path}`;
